import { ReactNode } from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon, IconDefinition } from '@sorare/core/src/atoms/icons';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Base = styled.div`
  padding-block: var(--unit);
  @media ${tabletAndAbove} {
    padding-block: var(--double-unit);
  }
`;

const Content = styled(Base)`
  padding-inline: var(--unit);
`;

const Label = styled(Base)`
  color: var(--c-neutral-600);
  text-align: right;
`;

type Props = {
  children: ReactNode;
  label: MessageDescriptor;
  icon?: IconDefinition;
};

export const Row = ({ children, label, icon }: Props) => (
  <>
    <Base className="text-center">
      {icon && <FontAwesomeIcon icon={icon} size="sm" />}
    </Base>
    <Content>{children}</Content>
    <Label>
      <FormattedMessage {...label} />
    </Label>
  </>
);
